/**
 * Quick-add pack sync
 *
 */
(() => {
  if (window.__quickAddPackSyncBound) return;
  window.__quickAddPackSyncBound = true;

  const MODAL_CONTENT_SELECTOR = '#quick-add-modal-content';
  const OPTION_INPUT_SELECTOR = 'input[type="radio"][data-input-id]';
  const ADD_TO_CART_FORM_SELECTOR = 'form[action*="/cart/add"]';

  const COLOR_POSITION = '1';
  const FORMAT_POSITION = '3';
  const PACK_LINK_CLASS = 'ray-quick-add-pack-link';

  const parseJSON = (root, id) => {
    const el = root.querySelector(`#${id}`);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch {
      return null;
    }
  };

  const getPackData = (modalContent) => {
    const variants = parseJSON(modalContent, 'ray-pack-variants-data');
    const meta = parseJSON(modalContent, 'ray-pack-meta');
    if (!variants || !variants.length || !meta) return null;
    return { variants, singleLabel: meta.single_format_label || '1 шт' };
  };

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const isPackFormat = (format, singleLabel) => {
    const value = normalize(format);
    return value !== '' && value !== normalize(singleLabel);
  };

  const findFieldsetInput = (form, position, value) => {
    return Array.from(form.querySelectorAll(OPTION_INPUT_SELECTOR)).find((input) => {
      return input.dataset.inputId?.startsWith(`${position}-`) && input.value === value;
    });
  };

  const getCheckedValue = (form, position) => {
    const checked = Array.from(form.querySelectorAll(OPTION_INPUT_SELECTOR)).find((input) => {
      return input.dataset.inputId?.startsWith(`${position}-`) && input.checked;
    });
    return checked ? checked.value : null;
  };

  const getFieldset = (form, position) => {
    const anyInput = form.querySelector(`${OPTION_INPUT_SELECTOR}[data-input-id^="${position}-"]`);
    return anyInput ? anyInput.closest('fieldset') : null;
  };

  const toggleColorFieldset = (form, packMode) => {
    const fieldset = getFieldset(form, COLOR_POSITION);
    if (!fieldset) return;

    fieldset.hidden = packMode;
    fieldset.style.display = packMode ? 'none' : '';
  };


  const togglePackLink = (form, packMode) => {
    const link = form.querySelector(`.${PACK_LINK_CLASS}`);
    if (!link) return;

    link.hidden = !packMode;
    if (packMode) link.textContent = link.dataset.packLinkText || '';
  };

  const toggleSubmitButton = (form, packMode) => {
    if (!form) return;

    const button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!button) return;

    if (packMode) {
      button.dataset.rayDisabledForPack = 'true';
      button.disabled = true;
    } else if (button.dataset.rayDisabledForPack) {
      delete button.dataset.rayDisabledForPack;
      button.disabled = false;
    }
  };

  const getAddToCartForm = (modalContent) => modalContent.querySelector(ADD_TO_CART_FORM_SELECTOR);

  const syncPickerState = (form, modalContent, packData) => {
    const format = getCheckedValue(form, FORMAT_POSITION);
    const packMode = isPackFormat(format, packData.singleLabel);

    toggleColorFieldset(form, packMode);
    togglePackLink(form, packMode);
    toggleSubmitButton(getAddToCartForm(modalContent), packMode);

    if (!packMode) return;

    const packVariants = packData.variants.filter((variant) => variant.option3 === format);
    if (!packVariants.length) return;

    const validColors = [...new Set(packVariants.map((variant) => variant.option1))];
    const currentColor = getCheckedValue(form, COLOR_POSITION);

    if (currentColor && validColors.includes(currentColor)) return;

    const nextColor =
      packVariants.find((variant) => variant.available)?.option1 || validColors[0];
    const nextColorInput = findFieldsetInput(form, COLOR_POSITION, nextColor);

    if (!nextColorInput || nextColorInput.checked) return;

    nextColorInput.checked = true;
    nextColorInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(OPTION_INPUT_SELECTOR)) return;

    const modalContent = input.closest(MODAL_CONTENT_SELECTOR);
    if (!modalContent) return;

    const form = input.closest('form');
    if (!form) return;

    const packData = getPackData(modalContent);
    if (!packData) return;

    syncPickerState(form, modalContent, packData);
  });

  document.addEventListener('variant:update', (event) => {
    const variantPicker = event.target;
    if (!(variantPicker instanceof HTMLElement)) return;

    const modalContent = variantPicker.closest(MODAL_CONTENT_SELECTOR);
    if (!modalContent) return;

    const form = variantPicker.querySelector('form');
    if (!form) return;

    const packData = getPackData(modalContent);
    if (!packData) return;

    syncPickerState(form, modalContent, packData);
  });

  const inferPackCount = (format) => {
    const match = String(format || '').match(/\d+/);
    const value = match ? Number(match[0]) : 1;
    return value > 1 ? value : 1;
  };

  const localizeFormat = (format) => {
    if (!document.documentElement.lang?.toLowerCase().startsWith('ru')) return format;
    return format.replace(/Набір/g, 'Набор').replace(/набір/g, 'набор');
  };

  const createGroupId = () => `ray-custom-pack-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

  const PROPERTY_NAMES = [
    '_ray_pack_type',
    '_ray_discount_key',
    '_ray_bundle_size',
    '_ray_bundle_id',
    '_ray_bundle_title',
  ];

  const clearInjectedProperties = (form) => {
    PROPERTY_NAMES.forEach((name) => {
      form.querySelector(`input[name="properties[${name}]"]`)?.remove();
    });
  };

  const injectProperty = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${name}]`;
    input.value = value;
    form.appendChild(input);
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button[type="submit"], input[type="submit"]');
      if (!button) return;

      const form = button.closest('form');
      if (!form) return;

      const modalContent = form.closest(MODAL_CONTENT_SELECTOR);
      if (!modalContent) return;

      const packData = getPackData(modalContent);
      if (!packData) return;

      clearInjectedProperties(form);

      const variantIdInput = form.querySelector('input[name="id"]');
      const variantId = variantIdInput ? Number(variantIdInput.value) : null;
      const variant = packData.variants.find((v) => v.id === variantId);

      if (!variant || !isPackFormat(variant.option3, packData.singleLabel)) return;

      const packCount = inferPackCount(variant.option3);

      injectProperty(form, '_ray_pack_type', 'ready');
      injectProperty(form, '_ray_discount_key', `ready-${packCount}`);
      injectProperty(form, '_ray_bundle_size', String(packCount));
      injectProperty(form, '_ray_bundle_id', createGroupId());
      injectProperty(form, '_ray_bundle_title', localizeFormat(variant.option3));
    },
    true
  );
})();
